var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import sha1 from 'sha1';
import axios from 'axios';
// Note that it is required to have a dataJs.checkout.dcc object loaded in the template
export const validateDoctorCode = (code, type = 'input') => __awaiter(void 0, void 0, void 0, function* () {
    let codes;
    if (type === 'url') {
        // Get a string with enctrypted URL doctor codes
        codes = yield axios.get('/cart?view=doctor-code').then((res) => {
            if (res.data) {
                return res.data.split(',');
            }
            return [];
        });
    }
    else {
        codes = dataJs.checkout.dcc.split(',');
    }
    if (code !== '') {
        const customerCode = sha1(code);
        const isFound = !!codes.find((itemCode) => {
            return itemCode === customerCode;
        });
        if (isFound) {
            return true;
        }
    }
    return false;
});
